import { render } from "./ListArticlesActionButtonsRenderer.vue?vue&type=template&id=b8c089b8"
import script from "./ListArticlesActionButtonsRenderer.vue?vue&type=script&lang=js"
export * from "./ListArticlesActionButtonsRenderer.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__